import { useEffect, useState } from 'react';

import {
  useCpmsBoLoginMutation,
  useCpmsBoRequestLoginOtpMutation,
  useCpmsBoVerifyLoginOTPMutation,
} from '@app/core/service/auth.service';

import { OtpStepView } from './otp-step.view';
import { EmailOtpForm } from './use-otp.form-validation';

export type EmailOtpStepControllerProps = {
  readonly emailAddress?: string;
  readonly onNext: (jwt: string, refreshToken: string) => void;
  readonly token?: string;
  readonly password?: string;
  readonly onSendOtpError: () => void;
};

export function OtpStepController({
  emailAddress,
  onNext,
  token,
  password,
  onSendOtpError,
}: EmailOtpStepControllerProps): React.JSX.Element {
  const [login, { isLoading: isLoginLoading, error: loginError }] =
    useCpmsBoLoginMutation();
  const [verifyOtp, { isLoading, error: verifyOtpError }] =
    useCpmsBoVerifyLoginOTPMutation();
  const [sendOtp, { isLoading: isOtpLoading, error: sendOtpError }] =
    useCpmsBoRequestLoginOtpMutation();
  const [loginRequestError, setLoginRequestError] = useState<boolean>();

  useEffect(() => {
    if (sendOtpError || loginError || loginRequestError) {
      onSendOtpError();
    }
  }, [sendOtpError, loginError, loginRequestError, onSendOtpError]);

  async function handleLogin(loginPayload: EmailOtpForm): Promise<void> {
    const result = await verifyOtp(loginPayload);

    if (result.data) {
      onNext(result.data.accessToken, result.data.refreshToken);
    }
  }

  const handleResendOtp = () => {
    if (emailAddress && token && password) {
      login({
        emailAddress,
        password,
      })
        .then(({ data }) => {
          if (!data) {
            return;
          }
          setLoginRequestError(false);
          sendOtp({
            emailAddress,
            token: data?.accessToken,
          });
        })
        .catch(() => {
          setLoginRequestError(true);
        });
    }
  };

  return (
    <OtpStepView
      pending={isLoading || isOtpLoading || isLoginLoading}
      emailAddress={emailAddress}
      onResendOtp={handleResendOtp}
      onSubmit={handleLogin}
      isError={!!verifyOtpError}
    />
  );
}
